import { ApolloLink } from 'apollo-link'
import { debounceUntilStable } from 'labguard-cdk'
import { Observable } from 'apollo-client/util/Observable'

/**
 * Custom link debouncing an outgoing operation if `debounce` is present in context
 */
export default new ApolloLink((operation, forward) =>
  operation.getContext().debounce
    ? new Observable(observer =>
        debounceUntilStable(operation.query, 200, () => forward(operation).subscribe(observer))
      )
    : forward(operation)
)
